import React from 'react'
import { Wrapper, ComponentWrapper, EmptyScreen } from './styles'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'

export function Unauthorized() {
  return (
    <Wrapper>
      <ComponentWrapper>
        <EmptyScreen
          title={'Unauthorized'}
          description={'You do not have access to this page'}
        />
      </ComponentWrapper>
    </Wrapper>
  )
}

export default withCommonSnapshotsOnly(Unauthorized)
